import { Fragment as CommonFragment } from "packages/react";

export const Fragment = CommonFragment;
